
import React from 'react';

const Pen = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M26.857 4.104a3.857 3.857 0 00-5.33-.07 3.552 3.552 0 00-5.02.01l-5.19 5.2 1.41 1.41 5.19-5.19c.6-.6 1.58-.61 2.19-.02l-13.79 13.8c-.11.11-.19.24-.24.39l-2 6c-.12.36-.03.76.24 1.02.19.19.45.29.71.29.11 0 .21-.02.32-.05l6-2c.15-.05.28-.13.39-.24l15.13-15.13c1.48-1.49 1.48-3.92-.01-5.42zm-1.41 1.42c.68.69.7 1.79.07 2.5l-2.57-2.57c.72-.63 1.82-.61 2.5.07zm-17.01 14.42l5.59-5.58 2.59 2.59-5.59 5.58-2.59-2.59zm7-7l6.09-6.09 2.59 2.59-6.09 6.09-2.59-2.59zm-7.97 8.86l1.71 1.71-2.57.86.86-2.57zM26 30H6v2h20v-2z'
			></path>
		</svg>
	);
};

export default Pen;
